import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";

const videos = [
  { title: "Unity Spray Tan Walk-Through Video", key: "QF6sRNKvDiQ" },
  { title: "Unity Pre and Post Tan Care", key: "XRT1OIPeAJw" },
  { title: "Barrier Cream", key: "ev6VxuiRw60" },
  { title: "Step Inside the Unity Booth!", key: "zSEyT_HXwW4" },
];

function VideoListPage() {
  const { t } = useTranslation("translation", { keyPrefix: "videoInstructions" });
  const navigate = useNavigate();

  const handleNavigate = (key) => {
    navigate(`/instructions/video/${key}`);
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>{t("videoListTitle", "Video List")}</h1>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {videos.map((video) => (
          <Button
            key={video.key}
            variant="primary"
            onClick={() => handleNavigate(video.key)}
          >
            {t("watchButton", "{{videoTitle}}", { videoTitle:video.title })}
          </Button>
        ))}
      </div>
    </div>
  );
}

export default VideoListPage;
